
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import * as OM from '@/Model'
import { ContractClient } from '@/services/Services';
import store from '@/store';

@Options({})
export default class startPercorsoModal extends Vue {


    @Prop() appUserBookingRequestVM: OM.AppUserBookingRequestVM;
    @Prop() categoryIdentifier: string;

    formBaseFields: OM.BaseFieldWithBookingConfigurationTypeBM[] = [];

    created(){
        ContractClient.getBookingForm(this.$store.state.user.companyIdentifier)
        .then(x => {
            this.formBaseFields = x
        })
    }

    get filteredBaseFields(){
        const role = (store.state.user?.role || '').toLowerCase()
        const isFamilyUser = role.indexOf('family') !== -1
        const typeFiltered = isFamilyUser
            ? OM.BookingConfigurationType.Family
            : OM.BookingConfigurationType.User

        return this.formBaseFields
            .filter((x) => {
            if (
                (x.bookingConfigurationType == typeFiltered ||
                x.bookingConfigurationType == OM.BookingConfigurationType.Both) &&
                (!x.categoryIdentifier || x.categoryIdentifier == this.categoryIdentifier)
            )
                return x
            })
            .map((x) => x.baseField)
    }

    ko(){
        this.$emit('close');
    }
}
